import { Alert } from '@mantine/core';
import { IconInfoCircle } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

import { useFetchAssetDetails } from 'src/Hooks/Queries/useFetchAssetDetails';

import styles from './AssetAboveQuotaAlert.module.scss';

const AssetAboveQuotaAlert = () => {
  const { t } = useTranslation();
  const { data } = useFetchAssetDetails();

  return (
    data && (
      <Alert
        color="orange"
        title={t('quotaAlert.title', 'Limite de stockage atteinte')}
        icon={<IconInfoCircle />}
        className={styles.alert}
      >
        <div className={styles.content}>
          {t(
            'quotaAlert.content',
            "Ce bien a atteint sa limite de stockage ou de vidéos. Il est en lecture seule : supprimez des fichiers ou des vidéos pour libérer de l'espace et réactiver les modifications."
          )}
        </div>
      </Alert>
    )
  );
};

export default AssetAboveQuotaAlert;
